// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AccountOperationType } from '../../AccountOperations';
export class CommissionItemParams {
    constructor() {
        this.AccountOperationType = AccountOperationType.Unknown;
        this.CommissionType = null;
        this.OperationType = null;
        this.Lots = null;
        this.Entry = [];
        this.IgnoreMinMaxCorrection = false;
        this.IsNotIgnoreAll = true;
        this.IgnoreUseInVat = true;
    }
}
